import classNames from "classnames"
import { useSharingMemberCount } from "features/overview/sharing-location/sharingMembers"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { useState } from "react"
import { selectActiveSearchPanelPlugin, setActiveSearchPanelPlugin } from "../slice"

export const OverviewSharingLocationFilter = () => {
    const dispatch = useAppDispatch()
    const [hovering, setHovering] = useState(false)
    const active = useAppSelector(selectActiveSearchPanelPlugin) === "members"
    const count = useSharingMemberCount()

    return (
        <div
            className={classNames(
                "flex items-center gap-2 rounded-full px-3 h-8 shadow-sm pointer-events-auto cursor-pointer transition-colors",
                {
                    "bg-black-600": !active && !hovering,
                    "bg-black-900": !active && hovering,
                    "bg-blue-500": active,
                }
            )}
            onClick={() => dispatch(setActiveSearchPanelPlugin(active ? undefined : "members"))}
            onMouseDown={(e) => e.stopPropagation()}
            onMouseEnter={() => setHovering(true)}
            onMouseLeave={() => setHovering(false)}
        >
            <div
                className={classNames("telegraf transition-colors", {
                    "text-gray-100": !active && !hovering,
                    "text-white": !active && hovering,
                    "text-gray-900": active,
                })}
            >
                Sharing Location
            </div>
            <div
                className={classNames(
                    "leading-none px-2 flex justify-center items-center rounded-full h-5 min-w-[30px] shrink-0 font-mono text-xs transition-colors",
                    {
                        "bg-white-100 text-gray-300": !active,
                        "bg-black-200 text-gray-700": active,
                    }
                )}
            >
                {count}
            </div>
        </div>
    )
}
